export default __webpack_public_path__ + "static/media/Camion1-t.16af59a4.png";